import { render } from "./UnFrozenMember.vue?vue&type=template&id=2eaf6fd5&scoped=true"
import script from "./UnFrozenMember.vue?vue&type=script&lang=js"
export * from "./UnFrozenMember.vue?vue&type=script&lang=js"

import "./UnFrozenMember.vue?vue&type=style&index=0&id=2eaf6fd5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eaf6fd5"]])

export default __exports__